import React from 'react';
import PropTypes from 'prop-types';

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

const ActionLink = (props) => {
  const { onClick, target, disabled, href } = props;

  const rest = {
    ...props,
    onClick: (event) => {
      if (disabled) {
        return;
      }
      try {
        if (onClick) onClick(event);
      } catch (ex) {
        event.preventDefault();
        throw ex;
      }

      if (
        !event.defaultPrevented && // onClick prevented default
        event.button === 0 && // ignore everything but left clicks
        (!target || target === '_self') && // let browser handle "target=_blank" etc.
        !isModifiedEvent(event) && // ignore clicks with modifier keys
        !href // if href passed, treat like regular link
      ) {
        event.preventDefault();
      }
    },
  };
  return <a {...rest}>{props.children}</a>;
};

ActionLink.defaultProps = {
  disabled: false,
};

ActionLink.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.object,
    PropTypes.array,
  ]),
  disabled: PropTypes.bool,
  href: PropTypes.string,
  onClick: PropTypes.func,
  target: PropTypes.string,
  className: PropTypes.string,
};

export default ActionLink;
